// @ts-nocheck

import type { BatteryFilterParams } from '../../../lib/types/filters';

export type { BatteryFilterParams } from '../../../lib/types/filters';

import React from 'react';
import styled from 'styled-components';
import Button from 'antd/lib/button';

import { ownerTypes } from '../../../lib/enum';
import { applyMaskToValue } from '../../../lib/helpers';


import { Selects, Card, Filter } from './../../../components';
import { Spoiler } from './../../../components/ui';
import Grid, { GridItem } from './../../../components/layout/Grid';

import { formatLicensePlateMask } from '../../../components/inputs/masked-inputs/LicensePlateInput';

const { BrandsSelect, VehicleSelect } = Selects;
const { Field } = Card;

const SpoilerContent = styled.div`
  padding: 16px;
`;
const Buttons = styled(GridItem)`
  margin: 0 -10px;
  & .ant-btn {
    margin: 0 10px;
  }
`;

















const BatteryFilter = ({ filter, cleanFilter, applyFilter }) =>
<Spoiler label="Фильтр">
    <SpoilerContent>
      <Grid gutter="16px">
        <Filter
        initialValues={filter}
        cleanFilter={cleanFilter}
        applyFilter={applyFilter}>

          {({
          values,
          changeValue,
          cleanFilter,
          applyFilter
        }) =>
        <>
              <GridItem>
                <Field label="Марка">
                  <BrandsSelect
                onChange={(value) => changeValue('brand.id', value)}
                value={values['brand.id']} />

                </Field>
              </GridItem>
              <GridItem>
                <Field label="Гос. номер">
                  <VehicleSelect
                placeholder="Все ТС"
                value={values.vehicleId}
                optionTitle={(vehicle) =>
                applyMaskToValue(
                  vehicle.licensePlate,
                  formatLicensePlateMask
                )
                }
                filter={{
                  ownerType: ownerTypes.self
                }}
                onChange={(value) => changeValue('vehicleId', value)} />

                </Field>
              </GridItem>
              <Buttons fullWidth>
                <Button type="primary" onClick={applyFilter}>
                  Применить
                </Button>
                <Button type="plain" onClick={cleanFilter}>
                  Очистить
                </Button>
              </Buttons>
            </>
        }
        </Filter>
      </Grid>
    </SpoilerContent>
  </Spoiler>;


export default BatteryFilter;
